import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const actions = {}

const mutations = {
  handleUserId: (state, userId) => {
    state.userId = userId
    localStorage.setItem('userId', userId)
  },
  handleUserName: (state, userName) => {
    state.userName = userName
    localStorage.setItem('userName', userName)
  },
  handleRemove: (state) => {
    state.userId = ''
    state.userName = ''
    localStorage.removeItem('userId')
    localStorage.removeItem('userName')
  },
  epidemicCountReduce: (state) => {
    state.epidemicCount--
  },
  setEpidemicCount: (state,epidemicCount) => {
    state.epidemicCount = epidemicCount
  },
}

const state = {
  userId: '' || localStorage.getItem('userId'),
  userName: '' || localStorage.getItem('userName'),
  epidemicCount: 0
}

const getters = {
  userId: (state) => state.userId,
  userName: (state) => state.userName,
  epidemicCount: (state) => state.epidemicCount,
}

const store = new Vuex.Store({
  actions,
  mutations,
  state,
  getters
})

export { store }



// WEBPACK FOOTER //
// ./src/store/store.js